import { useState } from 'react';
import { ZOOM_LEVELS } from '../lib';

export function useZoom(initialZoom = ZOOM_LEVELS[1]) {
  const [zoom, setZoom] = useState(initialZoom);

  const handleZoomOut = () => {
    const currentZoomIndex = ZOOM_LEVELS.findIndex((item) => item.value === zoom.value);
    const newZoomIndex = Math.max(currentZoomIndex - 1, 0);
    setZoom(ZOOM_LEVELS[newZoomIndex]);
  };

  const handleZoomIn = () => {
    const currentZoomIndex = ZOOM_LEVELS.findIndex((item) => item.value === zoom.value);
    const newZoomIndex = Math.min(currentZoomIndex + 1, ZOOM_LEVELS.length - 1);
    setZoom(ZOOM_LEVELS[newZoomIndex]);
  };

  return { zoom, handleZoomIn, handleZoomOut, setZoom };
}
